<template>
  <div class="home">
    <!-- 标语 -->
    <div class="slogan container" v-if="webPositionData[0]" @click="detailHandle(webPositionData[0]['infoData'][0])">
      <div v-if="webPositionData[0]['infoData'].length > 0">
        <h2>
          <img src="../assets/images/tag.png" alt="">
          {{ webPositionData[0]["infoData"][0]["strMasTitle"] }}

        </h2>
        <div class="tit-box">
          <span v-if="!!webPositionData[0]['infoData'][1]">{{webPositionData[0]['infoData'][1].strMasTitle}}</span>
          <span v-if="!!webPositionData[0]['infoData'][2]">{{webPositionData[0]['infoData'][2].strMasTitle}}</span>
          <span v-if="!!webPositionData[0]['infoData'][3]">{{webPositionData[0]['infoData'][3].strMasTitle}}</span>
          <span v-if="!!webPositionData[0]['infoData'][4]">{{webPositionData[0]['infoData'][4].strMasTitle}}</span>
        </div>
      </div>
      <div v-else class="no-content">暂无数据</div>
    </div>
    <div class="top container news-kms">
      <!-- Swiper -->
      <Vswiper v-if="webPositionData[1]" :isSpecial="isSpecial" :swiperArr="webPositionData[1]['infoData']"></Vswiper>
      <!-- 右侧新闻 -->
      <div class="news-main" v-if="webPositionData[3]">
        <div v-if="webPositionData[3]['infoData'].length>0">
          <div class="rows-zt" @click="detailHandle(webPositionData[3]['infoData'][0])" v-if="webPositionData[3]['infoData'][0]">
            <div class="tit-zt">
              {{webPositionData[3]['infoData'][0].strMasTitle}}
            </div>
            <div class="con-zt">
              {{webPositionData[3]['infoData'][0].strText}}
            </div>
          </div>
          <div class="rows-zt" @click="detailHandle(webPositionData[3]['infoData'][1])" v-if="webPositionData[3]['infoData'][1]">
            <div class="tit-zt">
              {{webPositionData[3]['infoData'][1].strMasTitle}}
            </div>
            <div class="con-zt">
              {{webPositionData[3]['infoData'][1].strText}}
            </div>
          </div>
          <ul v-if="webPositionData[3]['infoData'].length > 1">
            <li class="text-one" v-for="(item, index) in webPositionData[3]['infoData']" :key="index" @click="detailHandle(item)" v-show="1<index&&index<8">
              <span></span>
              {{ item.strMasTitle }}
            </li>

          </ul>
        </div>
        <div v-else class="no-content">暂无数据</div>

      </div>
    </div>

    <div class="picture-video container">
      <div class="picture" v-if="webPositionData[2]">
        <div class="name-box">
          <div class="meet-name">会议日程 ：</div>
          <div class="rc-box">
            <div class="rc-item" :class="index==indexMeet?'on':''" v-for="(item,index) in webPositionData[2]['infoData']" :key='index' @click='clickMeet(index)'>
              <img src="../assets/images/wz-icon.png" alt="" v-if="index==indexMeet">
            </div>

          </div>
        </div>
        <div class="meet-text" v-if="webPositionData[2]['infoData'].length>0">
          <div class="tit">{{webPositionData[2]['infoData'][indexMeet].strMasTitle}}</div>
          <div class="detail">
            <div class="detail-text" @click="detailHandle(webPositionData[2]['infoData'][indexMeet])">
              {{webPositionData[2]['infoData'][indexMeet].strText}}
            </div>
            <span>[详细]</span>
          </div>

        </div>

      </div>

    </div>
    <div class="qh-new-main ">
      <div class="container qh-flex">
        <div class="qh-new-item" v-if="webPositionData[4]">
          <div class="qh-item-tit">
            <span>
              {{webPositionData[4].strName}}
            </span>
          </div>
          <ul v-if="webPositionData[4]['infoData'].length>0">
            <li v-for="(item, index) in webPositionData[4]['infoData']" :key="index" @click="detailHandle(item)" v-show="index<5">
              <span class="tag-li">{{index+1}}</span>
              <span class="qh-li-text text-one">
                {{item.strMasTitle}}
              </span>
              <img src="../assets/images/list-bg-bottom.png" alt="">
            </li>

          </ul>
          <div v-else class="no-content">
            暂无数据
          </div>
        </div>
        <div class="qh-new-item" v-if="webPositionData[5]">
          <div class="qh-item-tit">
            <span>
              {{webPositionData[5].strName}}
            </span>
          </div>
          <ul v-if="webPositionData[5]['infoData'].length>0">
            <li v-for="(item, index) in webPositionData[5]['infoData']" :key="index" @click="detailHandle(item)" v-show="index<5">
              <span class="tag-li">{{index+1}}</span>
              <span class="qh-li-text text-one">
                {{item.strMasTitle}}
              </span>
              <img src="../assets/images/list-bg-bottom.png" alt="">
            </li>

          </ul>
          <div v-else class="no-content">
            暂无数据
          </div>
        </div>
      </div>
    </div>
    <div class="new-common-tit">
      委员声音
    </div>
    <div class="wy-new-main">
      <div class="container wy-flex">

        <div class="wy-new-item" v-if="webPositionData[6]">
          <div class="wy-item-tit">
            <span>
              {{webPositionData[6].strName}}
            </span>
          </div>
          <ul v-if="webPositionData[6]['infoData'].length>0">

            <li v-for="(item, index) in webPositionData[6]['infoData']" :key="index" @click="detailHandle(item)" v-show="index<5">
              <span class="tag-li"></span>
              <span class="wy-li-text text-one">
                {{item.strMasTitle}}
              </span>
            </li>

          </ul>
          <div v-else class="no-content">
            暂无数据
          </div>
        </div>
        <div class="wy-new-item" v-if="webPositionData[7]">
          <div class="wy-item-tit">
            <span>
              {{webPositionData[7].strName}}
            </span>
          </div>
          <ul v-if="webPositionData[7]['infoData'].length>0">

            <li v-for="(item, index) in webPositionData[7]['infoData']" :key="index" @click="detailHandle(item)" v-show="index<5">
              <span class="tag-li"></span>
              <span class="wy-li-text text-one">
                {{item.strMasTitle}}
              </span>
            </li>

          </ul>
          <div v-else class="no-content">
            暂无数据
          </div>
        </div>
      </div>
    </div>
    <div class="new-common-tit">
      委员风采
    </div>
    <div class="fc-swiper-main ">
      <div v-if="webPositionData[8]">
        <swiper :options="swiperOption" v-if="webPositionData[8]['infoData'].length>0">
          <swiper-slide class="swiper-slide" v-for="( item,index) in webPositionData[8]['infoData']" :key='index'>
            <router-link target="_blank" :to="{path: '/detail', query: { strWebSiteId: $route.query.strWebSiteId, strId: item.strId }}">
              <div class="img">
                <img :src="item.strPicPath" />
              </div>
              <span>{{item.strAuthor}}</span>
            </router-link>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <div v-else class="no-content">
          暂无数据
        </div>
      </div>
    </div>
    <div class="hy-swiper-main">
      <div v-if="webPositionData[9]">

        <swiper :options="hySwiperOption" v-if="webPositionData[9]['infoData'].length>0">

          <swiper-slide class="swiper-slide" v-for="( item,index) in webPositionData[9]['infoData']" :key='index'>
            <router-link target="_blank" :to="{path: '/detail', query: { strWebSiteId: $route.query.strWebSiteId, strId: item.strId }}">
              <img :src="item.strPicPath" />
            </router-link>
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
        <div v-else class="no-content">
          暂无数据
        </div>
      </div>

    </div>

    <!-- <div class="bgjd-main">
      <div class="new-common-tit">
        报告解读
      </div>
      <div class="bgjd-flex">

        <div class="bg-left">
          <ul>
            <li v-if="webPositionData[10]">
              <div class="tit-bg">工作回顾</div>
              <div class="bg-text" v-if="webPositionData[10]['infoData'].length>0" @click="detailHandle(webPositionData[10]['infoData'][0].strId)">
                {{webPositionData[10]['infoData'][0].strText}}
              </div>
              <div class="bg-text" v-else>
                暂无数据
              </div>
            </li>
            <li v-if="webPositionData[11]">
              <div class="tit-bg">成绩亮点</div>
              <div class="bg-text" v-if="webPositionData[11]['infoData'].length>0" @click="detailHandle(webPositionData[11]['infoData'][0].strId)">
                {{webPositionData[11]['infoData'][0].strText}}
              </div>
              <div class="bg-text" v-else>
                暂无数据
              </div>
            </li>
            <li v-if="webPositionData[12]">
              <div class="tit-bg">今年工作</div>
              <div class="bg-text" v-if="webPositionData[12]['infoData'].length>0" @click="detailHandle(webPositionData[12]['infoData'][0].strId)">
                {{webPositionData[12]['infoData'][0].strText}}
              </div>
              <div class="bg-text" v-else>
                暂无数据
              </div>
            </li>
          </ul>
        </div>
        <div class="bg-right">
          <div class="bg-right-t">
            <div v-if="webPositionData[13]">
              <swiper class="swiper" :options="bgSwiperOption" v-if="webPositionData[13]['infoData'].length>0">
                <swiper-slide v-for="( item,index) in webPositionData[13]['infoData']" :key='index'>
                  <router-link target="_blank" :to="{path: '/detail', query: { strWebSiteId: $route.query.strWebSiteId, strId: item.strId }}">
                    <img :src="item.strPicPath" />
                  </router-link>
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
              </swiper>
              <div v-else class="no-content">
                暂无数据
              </div>
            </div>

          </div>
          <div class="bg-right-b">
            <div v-if="webPositionData[14]">
              <swiper :options="bgSwiper" v-if="webPositionData[14]['infoData'].length>0" ref='bgSwiper'>
                <swiper-slide class="swiper-slide" v-for="( item,index) in webPositionData[14]['infoData']" :key='index'>
                  <router-link target="_blank" :to="{path: '/detail', query: { strWebSiteId: $route.query.strWebSiteId, strId: item.strId }}">
                    <img :src="item.strPicPath" />
                  </router-link>
                </swiper-slide>

              </swiper>
              <div v-else class="no-content">
                暂无数据
              </div>
            </div>

          </div>
        </div>
      </div>

    </div> -->

  </div>
</template>

<script>
import Vswiper from '@/components/base/swiper.vue'
import 'swiper/css/swiper.min.css'
import { homeData, bodyData, navigationForZx } from '@/api/configuration'
import { get } from '../utils/helpers'

export default {
  name: 'Home',
  components: {
    Vswiper
  },
  data () {
    return {
      photoWidth: '', // 精彩图片宽度
      calleft: 0, // 精彩图片左移尺寸
      webPositionData: [], // 中间内容列表
      navigationForZxArr: [], // 友情链接数据
      isSpecial: false,

      swiperOption: {
        slidesPerView: 4,

        //设置点击箭头
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        //自动轮播
        autoplay: {
          delay: 2000,
          // 当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true
      },
      hySwiperOption: {
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        allowTouchMove: false,
        centeredSlides: true,
        spaceBetween: 0,
        slidesOffsetBefore: 40,
        loop: true,
        slidesPerView: 'auto',
        on: {
          slideChangeTransitionEnd: function () {
            this.slides.transition(this.params.autoplay.delay + this.params.speed).transform('translate3d(-60px, 0, 0)');
          },
          slideChangeTransitionStart: function () {
            this.slides.transition(this.params.speed).transform('translate3d(0, 0, 0)');
          },
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      },
      bgSwiperOption: {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true

        }

      },
      /* eslint-disable no-new */
      bgSwiper: {

        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        slidesPerView: '4',
        spaceBetween: 20,
        slidesOffsetBefore: 105,
        slidesOffsetAfter: 100,
        // observer: true,//修改swiper自己或子元素时，自动初始化swiper
        // observeParents: true,//修改swiper

      },
      indexMeet: 0
    }
  },
  props: {},
  computed: {},
  created () {

    this.isSpecial =
      this.$route.query.strWebSiteId === 'b4a5ad6f2ad74fe6a2310d313bba36b7' ||
      this.$route.query.strWebSiteId === '4b4dc894e2894d4c966c03db2669de03'
    this.getInfoData() // 获取首页数据
    this.getNavigationForZx() // 获取友情链接数据
  },

  mounted () {


  },
  methods: {
    clickMeet (i) {
      this.indexMeet = i

    },
    //获取首页数据
    getInfoData () {
      const that = this
      homeData({
        strWebSiteId:
          this.$store.state.strWebSiteId || '9c6dfadce15643dd802277534a3f6b47'
      })
        .then(res => {
          let firstData = res.data.data
          document.title = firstData.strName
          const data = firstData.webPositionData
          data.forEach(async (v, k) => {
            let curObj = data[k]
            await bodyData({
              strColId: curObj.strColId,
              strColName: curObj.strColName,
              intCount: curObj.intCount
            })
              .then(res => {
                const secData = res.data.data
                that.$set(that.webPositionData, k, secData)
                if (k === 5 && secData.infoData && secData.infoData.length) {
                  that.photoWidth = 290 * Number(secData.infoData.length) * 2
                  that.move()
                }
                // console.log(that.webPositionData)
                // if (this.webPositionData[2]) {
                //   this.meetData[0] = this.webPositionData[2]['infoData'][0]
                //   console.log(JSON.stringify(this.meetData) + '=========00---------------')
                // }
              })
              .catch(err => {
                that.$message.destroy()
                that.$message.error(err)
              })
          })
        })
        .catch(err => {
          this.$message.destroy()
          this.$message.error(err)
        })
    },

    //获取友情链接数据
    getNavigationForZx () {
      navigationForZx({ strWebSiteId: this.$store.state.strWebSiteId })
        .then(res => {
          this.navigationForZxArr = get(['data'], res.data)
        })
        .catch(err => {
          this.$message.destroy()
          this.$message.error(err)
        })
    },

    //移动
    move () {
      this.timer = setInterval(this.starmove, 20)
    },

    //开始移动
    starmove () {
      this.calleft -= 0.6
      let lengthVal = this.webPositionData[5]['infoData'].length
      if (this.calleft <= -(290 * Number(lengthVal))) {
        this.calleft = 0
      }
    },

    //鼠标悬停时停止移动
    stopmove () {
      clearInterval(this.timer)
    },

    // 更多菜单跳转
    navHandle (strId) {
      let routeData = this.$router.resolve({
        path: '/list',
        query: { strWebSiteId: this.$route.query.strWebSiteId, strId: strId }
      })
      window.open(routeData.href, '_blank')
    },

    // 跳转详情
    detailHandle (i) {
      if (i.strUrlType == '_blank') {
        window.open(i.strUrl, i.strUrlType)

      } else {

        let routeData = this.$router.resolve({
          path: '/detail',
          query: { strWebSiteId: this.$route.query.strWebSiteId, strId: i.strId }
        })
        window.open(routeData.href, '_blank')
      }

    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="scss">
.bgjd-main {
  background: url('../assets/images/bg-bg.png') no-repeat center center;
  background-size: 100% 100%;
  .bgjd-flex {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }
  .bg-left {
    width: 50%;
    li {
      font-size: 14px;
      position: relative;
      padding-left: 100px;
      margin-bottom: 55px;
      padding-right: 30px;
      &:nth-child(2) {
        .bg-text {
          background-color: #fbb8b1;
        }
      }
      &:nth-child(3) {
        .bg-text {
          background-color: #fccd80;
        }
      }
      .bg-text {
        background-color: #c8dcfe;
        font-size: 14px;
        line-height: 24px;
        padding: 15px;
        border-radius: 10px;
        &::after {
          content: '';
          position: absolute;
          width: 2px;
          height: 100%;
          background-color: orange;
          left: 34px;
          top: 0px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: orange;
          left: 30px;
          top: 100%;
          // transform: translateX(-50%);
        }
      }
      &:last-child {
        .bg-text {
          // &::after {
          //   // content: '';
          //   height: 50%;
          //   // transform: translateX(-50%);
          // }
          &::before {
            top: 100%;
            // transform: translateX(-50%);
          }
        }
      }
      &:first-child {
        .tit-bg::after {
          display: none !important;
        }
      }
      .tit-bg {
        font-size: 14px;
        color: #fff;
        background: url('../assets/images/bgjd-tit-bg.png') no-repeat center
          center;
        background-size: 100% 100%;
        width: 80px;
        height: 55px;
        padding: 5px 20px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        &::after {
          content: '';
          position: absolute;
          width: 2px;
          height: 100%;
          background-color: orange;
          left: 34px;
          top: -55px;
        }
      }
      // &::after{
      //   content
      // }
    }
  }
  .bg-right {
    width: 50%;
    .bg-right-t {
      height: 280px;
      border: 1px solid #ddd;
      border-radius: 10px;
      .swiper {
        width: 600px;
        height: 280px;
        box-sizing: border-box;
        border: 1px solid #eee;
        border-radius: 10px;
        .swiper-slide {
          display: flex;
          justify-content: center;
          align-items: center;
          background-size: cover;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            margin: 0 auto;
          }
          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            height: 70px;
            line-height: 40px;
            box-sizing: border-box;
            padding: 2px 0 0 0;
            font-size: 18px;
            color: #fff;
            font-family: Verdana;
            margin: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: center;
            span {
              width: 85%;
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .swiper-pagination {
          bottom: 6px;
          box-sizing: border-box;
          padding: 0 5px;
          text-align: center;
          z-index: 1;
          right: 0;
          left: 0;
          width: auto;
          /deep/ .swiper-pagination-bullet {
            width: 12px !important;
            height: 12px !important;
            opacity: 1;
            background: #d9d9d9;
            &:hover {
              opacity: 1;
            }
            &.swiper-pagination-bullet-active {
              background: linear-gradient(90deg, #f71d1d, #fba548);
            }
          }
        }
      }
    }
    .bg-right-b {
      margin-top: 30px;
      .no-content {
        min-height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
      }
      .swiper-button-prev:after,
      .swiper-button-next:after {
        content: '' !important;
      }

      /deep/.swiper-container {
        // overflow: inherit;
        width: 100%;

        .swiper-wrapper {
          padding: 0 51px;
          box-sizing: border-box;
          // width: 1000px;
          .swiper-slide {
            position: relative;
            text-align: center;
            img {
              width: 100%;
              height: 130px;
              border-radius: 10px;
              // border-radius: 50%;
              // border: 1px solid #ffe9c5;
            }
          }
        }
      }
    }
  }
}
.hy-swiper-main {
  height: 600px;
  margin-top: 100px;
  /deep/.swiper-container {
    .swiper-slide {
      width: 978px;
      transition-timing-function: linear;
      position: relative;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
      content: '' !important;
    }
    .swiper-slide::after {
      content: '';
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      top: 0;
      left: 0;
    }
    .swiper-slide-active.swiper-slide::after {
      display: none;
    }
    .swiper-button-prev,
    .swiper-button-next {
      background: transparent;
      width: 22%;
      height: 100%;
      top: 0;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
    .swiper-slide img {
      width: 100%;
      height: 600px;
    }
  }
}
.fc-swiper-main {
  width: 100%;
  .swiper-button-prev:after,
  .swiper-button-next:after {
    content: '' !important;
  }

  .swiper-button-prev {
    width: 30px;
    height: 30px;
    left: 0px;
    background: url('../assets/images/wyfc-arrow-l.png') no-repeat center center;
    background-size: 100% 100%;
  }
  .swiper-button-next {
    width: 30px;
    height: 30px;
    right: 0px;
    background: url('../assets/images/wyfc-arrow-r.png') no-repeat center center;
    background-size: 100% 100%;
  }

  /deep/.swiper-container {
    // overflow: inherit;
    width: 1300px;

    .swiper-wrapper {
      padding: 0 51px;
      box-sizing: border-box;
      width: 1000px;
      .swiper-slide {
        position: relative;
        padding: 10px 0 10px 10px;

        .img {
          border: 3px solid #ffe9c5;
          border-radius: 50%;
          padding: 5px;
          width: 200px;
          height: 200px;
          // margin: 0 auto;
          box-shadow: 0px 1px 10px 5px #ffe9c5;
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid #ffe9c5;
        }
        span {
          position: absolute;
          left: 0px;
          bottom: 5px;
          font-size: 16px;
          font-weight: 700;
          width: 70px;
          height: 70px;
          background: #ffe9c5;
          text-align: center;
          line-height: 70px;
          border-radius: 50%;
          box-shadow: 0 0 10px 1px #cfc9c9;
        }
      }
    }
  }
}
.new-common-tit {
  font-size: 70px;
  color: #f00400;
  text-align: center;
  font-weight: 700;
  padding: 30px 0;
  font-family: cursive;
}
.wy-new-main {
  .no-content {
    background-color: #ffe9c5;
    border-radius: 10px;
    min-height: 190px !important;
  }
  .wy-flex {
    display: flex;
    .wy-new-item {
      width: 50%;
      &:first-child {
        padding-right: 25px;
      }
      &:last-child {
        padding-left: 25px;
      }
      ul {
        background-color: #ffe9c5;
        padding: 50px 50px;
        border-radius: 10px;
      }
      li {
        font-size: 16px;
        color: #333;
        height: 30px;
        line-height: 30px;
        position: relative;
        padding: 0 20px 0 20px;
        // background: #efefef;
        margin-bottom: 15px;
        cursor: pointer;
        .wy-li-text {
          width: 100%;
          display: inline-block;
        }

        .tag-li {
          width: 5px;
          height: 5px;
          background: #e60a12;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
        }
      }
      .wy-item-tit {
        margin-bottom: 36px;
        span {
          background: url('../assets/images/list-tit-bg-2.png') no-repeat center
            center;
          background-size: 100% 100%;
          font-size: 24px;
          color: #fff;
          font-weight: 700;
          padding: 10px 50px 30px 50px;
        }
      }
    }
  }
}
.qh-new-main {
  background: url('../assets/images/qh-bg.png') no-repeat center center;
  background-size: 100% 130%;
  padding-bottom: 35px;
  padding-top: 30px;

  .qh-flex {
    display: flex;
  }
  .qh-new-item {
    width: 50%;
    &:first-child {
      padding-right: 25px;
    }
    &:last-child {
      padding-left: 25px;
    }
    li {
      font-size: 16px;
      color: #333;
      height: 50px;
      line-height: 50px;
      position: relative;
      padding: 0 20px 0 90px;
      background: #efefef;
      margin-bottom: 20px;
      cursor: pointer;
      .qh-li-text {
        width: 100%;
        display: inline-block;
      }
      img {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 16px;
      }
      .tag-li {
        width: 70px;
        height: 100%;
        background: url('../assets/images/li-bg.png') no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 0;
        line-height: 50px;
        text-align: center;
        font-weight: 700;
        color: #fff;
        font-size: 20px;
      }
    }
    .qh-item-tit {
      text-align: center;
      margin-bottom: 50px;
      span {
        background: url('../assets/images/list-tit-bg.png') no-repeat center
          center;
        background-size: 100% 100%;
        font-size: 36px;
        color: #fff;
        font-weight: 700;
        padding: 10px 40px;
      }
    }
  }
}
.news-kms {
  position: relative;
  .news-main {
    padding: 0 30px;
    width: 600px;
    position: absolute;
    top: 0;
    right: 0;
    .rows-zt {
      border-bottom: 1px dashed #bababa;
      margin-bottom: 15px;
      cursor: pointer;
      .tit-zt {
        font-size: 20px;
        color: #f00400;
        font-weight: 700;
        padding-bottom: 10px;
      }
      .con-zt {
        font-size: 14px;
        margin-bottom: 15px;
        color: #727272;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    ul {
      li {
        position: relative;
        font-size: 16px;
        color: #333;
        line-height: 20px;
        padding: 10px 0 10px 20px;
        span {
          width: 5px;
          height: 5px;
          background: #e60a12;
          position: absolute;
          left: 2px;
          top: 50%;
          transform: translateY(-50%) rotate(45deg);
        }
      }
    }
  }
}
.home {
  // background: url('../assets/images/bg1.png') no-repeat center top,
  //   url('../assets/images/bg2.png') no-repeat center bottom;
  padding: 65px 0 0px;
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .no-content {
    box-sizing: border-box;
    font-size: 18px;
    text-align: center;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slogan {
    box-sizing: border-box;
    padding: 50px 15px 30px;
    .tit-box {
      text-align: center;
      span {
        font-size: 14px;
        color: #545454;
        padding: 0 15px;
        border-right: 1px solid #545454;
        &:last-child {
          border-right: none;
        }
      }
    }
    h2 {
      font-size: 36px;
      font-weight: bold;
      color: #f00400;
      line-height: 45px;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        width: 45px;
      }
    }
    p {
      font-size: 18px;
      color: #333333;
      line-height: 28px;
    }
    i {
      display: inline-block;
      font-style: normal;
      color: #bb2c1b;
      cursor: pointer;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    .tit {
      color: #e40000;
      font-size: 30px;
      font-weight: bold;
      border-left: 8px solid #e40000;
      padding-left: 17px;
      margin: 50px 0 45px 25px;
    }
    & > .news {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      .title {
        background: url('../assets/images/tips.png') no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        padding: 0 0 0 20px;
        span {
          font-size: 28px;
          font-weight: bold;
          color: #ce0801;
          line-height: 16px;
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }
      ul {
        margin-top: 10px;
        li {
          background: url('../assets/images/tips2.png') no-repeat 0 center;
          font-size: 20px;
          color: #333;
          line-height: 25px;
          box-sizing: border-box;
          padding: 15px 0 15px 15px;
          // margin: 16px  0;
          cursor: pointer;
          border-bottom: 1px dashed #ddd;
          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .picture-video {
    margin: 15px auto 50px;
    display: flex;
    justify-content: space-between;
    .picture {
      width: 600px;
      height: 180px;
      background: url('../assets/images/schedule-bg.png') no-repeat left center;
      background-size: 100%;
      position: relative;
      .meet-text {
        width: 50%;
        position: absolute;
        color: #444444;
        font-size: 16px;
        left: 55%;
        top: 110px;
        transform: translate(-50%, -50%);

        .tit {
          color: #f00400;
          font-weight: 700;
          font-size: 18px;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .detail {
          margin-bottom: 5px;
          width: 100%;
          position: relative;
          padding-right: 45px;
          .detail-text {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
          }
          span {
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
          }
        }
        .time {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .name-box {
        position: absolute;
        left: 133px;
        top: 11px;
        width: 350px;
        padding-left: 100px;
        .meet-name {
          color: #fff;
          font-size: 18px;
          position: absolute;
          left: 0px;
          top: 5px;
        }
        .rc-box {
          overflow-x: auto;
          white-space: nowrap;
          // /* width: 100px; */
          height: 35px;

          .rc-item {
            float: left;
            width: 50px;
            height: 24px;
            position: relative;
            &.on {
              &::before {
                background-color: #f8c985 !important;
              }
            }
            img {
              width: 18px;
            }
            &:last-child {
              &::after {
                display: none !important;
              }
            }
            &::before {
              content: '';
              position: absolute;
              bottom: -10px;
              left: 5px;
              width: 8px;
              height: 8px;
              background-color: #fff;
              border-radius: 50%;
              z-index: 2;
            }
            &::after {
              content: '';
              position: absolute;
              bottom: -7px;
              left: 6px;
              width: 100%;
              height: 1px;
              background-color: #e88969;
            }
          }
        }
      }
    }
    .video {
      margin-left: 25px;
      box-sizing: border-box;
      padding-right: 20px;
      flex: 1;
      overflow: hidden;
      margin-top: -50px;
      .title {
        background: url('../assets/images/tips.png') no-repeat 0 center;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: border-box;
        padding: 0 0 0 20px;
        margin-bottom: 20px;
        span {
          font-size: 28px;
          font-weight: bold;
          color: #ce0801;
          line-height: 16px;
        }
        i {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #333333;
          line-height: 30px;
          font-style: normal;
          cursor: pointer;
        }
      }
      ul {
        height: 235px;
        li {
          position: relative;
          img {
            display: block;
            width: 100%;
            height: 235px;
          }
          p {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            line-height: 37px;
            background: rgba(0, 0, 0, 0.6);
            box-sizing: border-box;
            padding: 0 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 18px;
            font-family: Verdana;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
  .conference {
    .title {
      margin: 0 auto 30px;
      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      .left {
        width: 600px;
        height: 415px;
        .no-content {
          width: 600px;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }
        & > div {
          position: relative;
        }
        img {
          display: block;
          width: 100%;
          height: 415px;
        }
        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0;
          line-height: 37px;
          background: rgba(0, 0, 0, 0.6);
          box-sizing: border-box;
          padding: 0 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 18px;
          font-family: Verdana;
          color: #fff;
          cursor: pointer;
        }
      }
      .right {
        box-sizing: border-box;
        padding-right: 20px;
        flex: 1;
        overflow: hidden;
        &:nth-child(2) {
          margin-left: 45px;
        }
        .no-content {
          width: 100%;
          height: 415px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }
        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: row wrap;
          li {
            &:nth-child(odd) {
              width: 50%;
            }
            &:nth-child(even) {
              width: calc(50% - 35px);
            }
            div {
              background: url('../assets/images/tips2.png') no-repeat 0 center;
              font-size: 20px;
              color: #333;
              line-height: 25px;
              box-sizing: border-box;
              padding: 15px 0 15px 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
              border-bottom: 1px dashed #ddd;
            }
          }
        }
      }
    }
  }
  .photo-gallery {
    .threeImg .containt {
      position: relative;
      overflow-y: auto;
      width: 1200px;
      height: 165px;
      overflow: hidden;
      margin: 30px auto 10px;
      ul {
        margin: 0 auto;
        width: 2000px;
        position: absolute;
        left: 0px;
        height: 100%;
        z-index: 10;
        li {
          float: left;
          width: 240px;
          height: 165px;
          margin-right: 50px;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 135px;
          }
          p {
            display: block;
            width: 100%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #3273dc;
            font-size: 16px;
            cursor: pointer;
            line-height: 40px;
          }
        }
      }
    }
  }
  .links {
    .tit {
      margin: 50px auto 30px;
      img {
        display: block;
        width: auto;
        max-width: 100%;
        height: auto;
        margin: 0 auto;
      }
    }
    ul li {
      width: 190px;
      margin: 0 5px 0;
      cursor: pointer;
      img {
        display: block;
        margin: 0 auto;
        width: 190px;
        height: 85px;
        border: 1px solid #eee;
      }
    }
  }
}
</style>
